export const NFHS_READER_ORIGIN = 'https://rules.nfhsdigital.org'

const LOGOUT_PENDING_KEY = 'refreps.nfhsEmbedLogoutPending'

export function nfhsLogoutMessage() {
  return { source: 'refreps', type: 'logout' }
}

export function nfhsSignedOutSessionMessage() {
  return { source: 'refreps', type: 'session', user: null, session: null }
}

export function isNfhsReaderMessage(data) {
  return Boolean(data)
    && data.source === 'nfhs-rules'
    && typeof data.type === 'string'
}

export function postNfhsEmbedLogout(targetWindow) {
  if (!targetWindow || typeof targetWindow.postMessage !== 'function') return
  targetWindow.postMessage(nfhsLogoutMessage(), NFHS_READER_ORIGIN)
  targetWindow.postMessage(nfhsSignedOutSessionMessage(), NFHS_READER_ORIGIN)
}

export function markNfhsEmbedLogoutPending() {
  try {
    localStorage.setItem(LOGOUT_PENDING_KEY, '1')
  } catch {
    // Private mode can block storage. Open readers still get the message directly.
  }
}

export function nfhsEmbedLogoutIsPending() {
  try {
    return localStorage.getItem(LOGOUT_PENDING_KEY) === '1'
  } catch {
    return false
  }
}

export function clearNfhsEmbedLogoutPending() {
  try {
    localStorage.removeItem(LOGOUT_PENDING_KEY)
  } catch {
    // Ignore storage failures.
  }
}

/**
 * Tell any open NFHS reader to sign out. Does not load a new reader, so
 * RefReps can navigate to login immediately. If no reader is open, the next
 * one that says it is ready still receives the sign-out.
 */
export function requestNfhsEmbedLogout() {
  markNfhsEmbedLogoutPending()
  if (typeof document === 'undefined') return
  document.querySelectorAll('iframe.nfhs-reader-iframe').forEach((frame) => {
    postNfhsEmbedLogout(frame.contentWindow)
  })
}
